<template>
  <init-title>
    <template v-slot:content>
      <el-form ref="userApplication" :model="dataForm" :rules="rules"
               class="form base-margin__top-20 form_width_500" label-position="top">
        <el-form-item :label="$t('projectApply.inviteCode')" prop="inviteCode">
          <el-input v-model="dataForm.inviteCode"
                    :placeholder="$t('projectApply.enterInviteCode')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('projectApply.remark')" prop="applyMessage">
          <el-input
            v-model="dataForm.applyMessage"
            :autosize="{ minRows: 6, maxRows: 6 }"
            :placeholder="$t('projectApply.enterApplyContent')"
            maxlength="200"
            show-word-limit
            type="textarea">
          </el-input>
        </el-form-item>
      </el-form>
      <div class="base-flex__between base-margin__bottom-20">
        <el-button class="base-margin__center" type="primary" @click="submit">
          {{ $t('projectApply.submitApplication') }}
        </el-button>
      </div>
    </template>
  </init-title>
</template>

<script>
import initTitle from '@/components/initTitle/index.vue';
import { postRequest } from '@/common/libs/request';

export default {
  name: 'App',
  data() {
    return {
      dataForm: {
        inviteCode: '',
        applyMessage: '',
      },
      rules: {
        inviteCode: [
          { required: true, message: this.$t('projectApply.inviteCodeRequired'), trigger: 'blur' },
          { min: 7, max: 7, message: this.$t('projectApply.inviteCodeLength'), trigger: 'blur' },
        ],
        applyMessage: [
          { required: true, message: this.$t('projectApply.remarkRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('projectApply.remarkMaxLength'), trigger: 'blur' },
        ],
      },
    };
  },
  components: {
    initTitle,
  },
  methods: {
    async submit() {
      this.$refs.userApplication.validate((valid) => {
        if (valid) {
          try {
            postRequest('/api/eda/common/eda/projectJoin', {
              invitationCode: this.dataForm.inviteCode,
              content: this.dataForm.applyMessage,
            }).then(() => {
              this.$message.success(this.$t('projectApply.applicationSubmitted'));
              this.$emit('click', '');
            });
          } catch (e) {
            this.$message(this.$t('projectApply.submitFailed'));
          }
        }
      });
    },
  },
};
</script>

<style>
.form_width_500 {
  width: 500px;
}
</style>
